import React from "react";
import { ChevronDown } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1650804068570-7fb2e3dbf888?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export default function Hero({ onOpenQuote }) {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen w-full overflow-hidden grain">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Granit i marmur — Kamieniarstwo Mrozek"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black/85" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-transparent to-transparent" />
      </div>

      {/* Top frame line */}
      <div className="absolute top-24 left-6 right-6 md:left-12 md:right-12 h-px bg-white/10" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 pt-40 md:pt-44 pb-20 min-h-screen flex flex-col justify-center">
        <p data-testid="hero-overline" className="overline mb-8">
          Rodzinna pracownia · Od pokoleń
        </p>

        <h1
          data-testid="hero-headline"
          className="section-title text-white text-[2.6rem] leading-[1.02] sm:text-6xl md:text-7xl lg:text-[6.4rem] max-w-5xl"
        >
          Tradycja, precyzja
          <br />
          <span className="italic font-light text-neutral-200">i&nbsp;trwałość</span> zaklęte
          <br />w&nbsp;kamieniu.
        </h1>

        <p
          data-testid="hero-subheadline"
          className="mt-10 max-w-2xl text-neutral-300 text-base md:text-lg leading-relaxed"
        >
          Specjalizujemy się w produkcji nagrobków, parapetów, schodów oraz elementów kamiennych
          wykonywanych z najwyższej jakości granitu, marmuru i konglomeratów. Łączymy
          wieloletnie doświadczenie z nowoczesnymi technologiami obróbki kamienia.
        </p>

        <div className="mt-12 flex flex-wrap gap-4">
          <button data-testid="hero-cta-quote" className="btn-primary" onClick={onOpenQuote}>
            Darmowa wycena
          </button>
          <button data-testid="hero-cta-gallery" className="btn-ghost" onClick={() => scrollTo("galeria")}>
            Zobacz realizacje
          </button>
          <button data-testid="hero-cta-contact" className="btn-ghost" onClick={() => scrollTo("kontakt")}>
            Skontaktuj się
          </button>
        </div>

        {/* Side meta */}
        <div className="hidden md:flex absolute right-12 bottom-28 flex-col items-end gap-3 text-right">
          <p className="overline text-neutral-400">est.</p>
          <p className="font-serif-display text-5xl text-white/90 leading-none">1995</p>
          <p className="text-xs uppercase tracking-[0.3em] text-neutral-500">Chałupki · Paczków</p>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => scrollTo("o-nas")}
        className="absolute left-1/2 -translate-x-1/2 bottom-8 flex flex-col items-center gap-2 text-neutral-400 hover:text-white transition-colors"
        aria-label="Przewiń niżej"
      >
        <span className="text-[10px] uppercase tracking-[0.4em]">Scroll</span>
        <ChevronDown size={18} className="animate-bounce" strokeWidth={1} />
      </button>
    </section>
  );
}
